import { gql } from '@apollo/client'

export const Query = gql`
  query ProductMultiplierTypes(
    $companyId: ID!,
    $filters: ProductMultiplierTypeFilters,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    productMultiplierTypes(
      companyId: $companyId,
      filters: $filters,
      after: $after,
      before: $before,
      first: $first,
      last: $last
    ) {
      nodes {
        id
        multiplierType {
          id
          name
          multiplierType
          summary
        }
        product {
          ... on AssetType {
            id
            name
          }
        }
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
